"use client";

import { RouteError } from "@/components/errors/routeError.component";

import { BUILD_MY_SYSTEM_PAGE, SHOP_PAGE } from "@/constants/page.constants";

const ShopError = ({ error, reset }: ShopErrorProps) => {
  return (
    <RouteError
      error={error}
      reset={reset}
      route="shop"
      title="Something went wrong"
      description="We couldn't load this page. Try again or continue browsing the shop."
      links={[
        { href: SHOP_PAGE, label: "Continue shopping" },
        {
          href: BUILD_MY_SYSTEM_PAGE,
          label: "Build My System",
          border: true,
        },
      ]}
    />
  );
};

export default ShopError;

type ShopErrorProps = {
  error: Error & { digest?: string };
  reset: () => void;
};
